"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashTree = void 0;
const buffer_1 = require("./buffer");
const sha256_1 = require("./sha256");
function hashTree(items) {
    const hashes = items.map((i) => (0, sha256_1.sha256)(i));
    while (hashes.length > 1) {
        let i = 0; // hashes index
        let p = 0; // pointer
        while (i < hashes.length) {
            if (i === hashes.length - 1) {
                // Move the last "alone" leaf to the pointer
                hashes[p] = hashes[i];
                i += 1;
            }
            else {
                hashes[p] = (0, sha256_1.sha256)(buffer_1.Buffer.concat([hashes[i], hashes[i + 1]]));
                i += 2;
            }
            p += 1;
        }
        hashes.length = p;
    }
    return hashes[0];
}
exports.hashTree = hashTree;
//# sourceMappingURL=hash_tree.js.map